module.exports = __webpack_public_path__ + "img/logo_footer.16e55034.svg";